// extracted by mini-css-extract-plugin
export var businessWorkGallerySection = "template-module--businessWorkGallerySection--8153f";
export var galleryImg = "template-module--galleryImg--00b82";
export var left = "template-module--left--6ef64";
export var topBusinessSection = "template-module--topBusinessSection--d1729";
export var topBusinessTextWrapper = "template-module--topBusinessTextWrapper--61433";
export var topBusinessWrapper = "template-module--topBusinessWrapper--c0a28";
export var topPointBottomWrapper = "template-module--topPointBottomWrapper--92dc9";
export var topPointTopWrapper = "template-module--topPointTopWrapper--53365";
export var topPointWrapper = "template-module--topPointWrapper--4e1bc";
export var topStaff = "template-module--topStaff--74717";
export var topStaffBottomWrapper = "template-module--topStaffBottomWrapper--dc364";
export var topStaffSection = "template-module--topStaffSection--63852";
export var topStaffWrapper = "template-module--topStaffWrapper--d73eb";